module.exports = __webpack_public_path__ + "static/img/40002 (1).632ab93.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40002 (1).webp
// module id = ixwi
// module chunks = 14